const contentful = require('contentful');

const client = contentful.createClient({
  space: process.env.GATSBY_CONTENTFUL_SPACE,
  accessToken: process.env.GATSBY_CONTENTFUL_ACCESS_TOKEN,
  environment: 'master',
});


module.exports.fetchLocations = function fetchLocations(continent) {
    return client.getEntries({
        content_type: 'holbornOffices',
        order: 'fields.order',
        'fields.continent': continent !== 'all' ? continent : undefined
    });
};